<script setup>
  import { Trash, Plus } from "lucide-vue-next";
  import { Button } from "@/components/ui/button";
  import { Select } from "@/components/episto-ui/select";
  import { Switch } from "@/components/ui/switch";
  import { Label } from "@/components/ui/label";
  import { Tooltip } from "@/components/ui/tooltip";
  import { useProfileQuestionParamsStore } from "@stores/survey/profiles/profileQuestionParams";
  import { storeToRefs } from "pinia";

  const profileQuestionParamsStore = useProfileQuestionParamsStore();
  const { currentQuestionParams, cardTokenOptions, typeOptions } = storeToRefs(profileQuestionParamsStore);
  const { addQuestionParam, removeQuestionParam, updateCardToken, cardTokenModel, answerOptions } =
    profileQuestionParamsStore;
</script>

<template>
  <div class="space-y-2">
    <div class="flex items-baseline justify-between">
      <Label>Forced answers</Label>
      <span class="text-xs text-muted-foreground">Other questions are answered at random</span>
    </div>

    <div
      v-if="currentQuestionParams.length > 0"
      class="space-y-1.5">
      <div
        v-for="(item, index) in currentQuestionParams"
        :key="`profileparam-${index}`"
        class="flex items-center gap-2">
        <Select
          :model-value="cardTokenModel(item.card_token)"
          :options="cardTokenOptions"
          filterable
          placeholder="Question"
          class="h-9 min-w-0 flex-[3]"
          @update:model-value="updateCardToken(index, $event)" />
        <div class="w-24 shrink-0">
          <Select
            :model-value="item.type"
            :options="typeOptions"
            class="h-9"
            @update:model-value="(val) => (item.type = val)" />
        </div>
        <Select
          :model-value="item.answers"
          :options="answerOptions(item)"
          creatable
          filterable
          multiple
          placeholder="Select answers"
          class="min-h-9 min-w-0 flex-[4]"
          @update:model-value="(val) => (item.answers = val)" />
        <Tooltip content="Pick all these answers">
          <span class="flex shrink-0">
            <Switch v-model="item.select_all" />
          </span>
        </Tooltip>
        <Button
          variant="ghost"
          size="icon-sm"
          class="shrink-0 text-foreground-subtle hover:text-primary"
          aria-label="Remove this forced answer"
          @click="removeQuestionParam(index)">
          <Trash class="size-3.5" />
        </Button>
      </div>
    </div>

    <Button
      variant="outline"
      @click="addQuestionParam">
      <Plus class="h-4 w-4" />
      Force an answer
    </Button>
  </div>
</template>
